import { z } from 'zod'
import { MEETING_FEEDBACK_COMMENT_MAX_LENGTH } from '@/constants/meeting'

export function createMeetingFeedbackSchema(commentTooLongMessage: string) {
  return z.object({
    rating: z.number().min(0).max(5),
    comment: z.string().trim().max(MEETING_FEEDBACK_COMMENT_MAX_LENGTH, {
      message: commentTooLongMessage,
    }),
  })
}

export type MeetingFeedbackFormValues = z.infer<ReturnType<typeof createMeetingFeedbackSchema>>
